<air-hero [showPartnersList]="true" [loading]="true"></air-hero>
<div class="container content loading">
  <div class="content-section">
    <div class="content-panel">
      <div class="content content--primary grid">
        <div class="col-12 col-6--md col-4--sm"></div>
      </div>
    </div>
  </div>
</div>
